import { render } from "./ActionButtons.vue?vue&type=template&id=64c95c82"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"

import "./ActionButtons.vue?vue&type=style&index=0&id=64c95c82&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__